
import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, ShoppingBag } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';

const OilCtaSection = () => {
  const isMobile = useIsMobile();
  
  return (
    <section className="section-padding bg-white border-t border-autocare-gray-medium/20">
      <div className="page-container">
        <div className="text-center text-autocare-blue max-w-3xl mx-auto">
          <h2 className="text-2xl md:text-4xl font-bold mb-4 sm:mb-6">هل أنت مستعد لتغيير الزيت القادم؟</h2>
          <p className="text-gray-600 text-sm md:text-lg mb-6 sm:mb-8 px-2">
            اعثر على الزيت المناسب واحجز موعداً مع مقدم خدمة موثوق بالقرب منك.
          </p>
          <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4">
            <Link to="/products" className="btn-primary flex items-center justify-center text-sm sm:text-base py-2 px-4 sm:py-3 sm:px-6">
              <ShoppingBag className="h-4 w-4 sm:h-5 sm:w-5 mr-2" />
              تسوق منتجات الزيوت
            </Link>
            <Link to="/shops" className="btn-secondary flex items-center justify-center text-sm sm:text-base py-2 px-4 sm:py-3 sm:px-6">
              <Calendar className="h-4 w-4 sm:h-5 sm:w-5 mr-2" />
              حجز موعد
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OilCtaSection;
